<template>
   <BaseContainer class="pb16 bg_white">
    <div class="welcome_call_wrap">
      <div class="logo">
        <img :src="require('@/assets/images/welcomeCall/start-logo.svg')" alt="">
      </div>
      <div class="text_wrap">
        <button
          @click="onClickStart"
          type="button" name="button"
          onClick="android.close()"
          class="btn btn_blue start_btn ab"
        >
          はじめる<br><span class="small">Tap to start</span>
        </button>
      </div>
    </div>
  </BaseContainer>
</template>

<script>
import close from '@/model/closeWebView'
import BaseContainer from '@/components/common/BaseContainer.vue';

export default {
  components: {
    BaseContainer,
  },
  methods: {
    onClickStart() {
      close.closeWebView();
    },
  },
};
</script>


<style lang="css" scoped>
.welcome_call_wrap {
  padding-top: 60px;
}
.logo {
  max-width: 271px;
  margin: 0 auto;
}
.text_wrap {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.start_btn {
  border-radius: 51px;
  font-size: 18px;
  letter-spacing: 5px;
  line-height: 1;
  max-width: 220px;
  margin: 0 auto;
  padding: 13px;
}
.small {
  font-size: 10px;
  letter-spacing: 1px;
  /* margin-top: 4px; */
}
</style>



// WEBPACK FOOTER //
// src/views/welcomeCall/GettingStart.vue